// Shared helpers for the community matching modes (classic / swipe / quick pick).
// All three pages share one anonymous session, one stats object and one daily goal,
// so switching modes never resets someone's progress.

const IMAGES_URL = process.env.NEXT_PUBLIC_IMAGES_URL || '/images';

export function imgUrl(path) {
  if (!path) return '';
  if (path.startsWith('/images')) return IMAGES_URL + path.slice(7);
  return IMAGES_URL + '/' + path;
}

export function getSessionId() {
  if (typeof window === 'undefined') return '';
  let id = localStorage.getItem('matching_session_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('matching_session_id', id);
  }
  return id;
}

export function getStoredStats() {
  if (typeof window === 'undefined') return { totalReviewed: 0, streak: 0, bestStreak: 0 };
  try {
    const stored = JSON.parse(localStorage.getItem('matching_stats') || '{}');
    return { totalReviewed: stored.totalReviewed || 0, streak: stored.streak || 0, bestStreak: stored.bestStreak || 0 };
  } catch { return { totalReviewed: 0, streak: 0, bestStreak: 0 }; }
}

export function saveStats(stats) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('matching_stats', JSON.stringify(stats));
  }
}

// ---- Daily goal (shared across all matching modes) ----

export const DAILY_GOAL = 25;

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function getDailyCount() {
  if (typeof window === 'undefined') return 0;
  try {
    const stored = JSON.parse(localStorage.getItem('matching_daily') || '{}');
    return stored.date === todayKey() ? (stored.count || 0) : 0;
  } catch { return 0; }
}

// Increments today's counter and reports whether this increment crossed the goal
// (so the caller fires the celebration exactly once per day).
export function incrementDailyCount(n = 1) {
  if (typeof window === 'undefined') return { count: n, reachedGoal: false };
  const before = getDailyCount();
  const count = before + n;
  try {
    localStorage.setItem('matching_daily', JSON.stringify({ date: todayKey(), count }));
  } catch { /* localStorage unavailable */ }
  return { count, reachedGoal: before < DAILY_GOAL && count >= DAILY_GOAL };
}
